<template>
	<div class="form popup-form">
		<h3 class="popup-tilte">Ingatlan kiválasztása</h3>
		<label class="select-label d-table w-100 text-center" v-if="getRealEstates.length === 0">
			Még nincs rögzített ingatlanadat.
		</label>
		<label class="select-label d-table w-100 text-center" v-else>
			{{ getRealEstates.length > 1 ? 'Elérhető ingatlan adatok' : 'Elérhető ingatlan adatok:' }}
		</label>
		<span class="d-flex fs-bold justify-center mt-12px text-center" v-if="getRealEstates.length === 1">
			{{ makeAddress(getRealEstates[0]) }}
		</span>
		<div class="w-100" v-if="getRealEstates.length > 1">
			<select name="real_estate" class="mw-500px d-table" v-model="selected">
				<option v-for="(real_estate, index) in getRealEstates" :key="index" :value="real_estate.id">
					{{ makeAddress(real_estate) }}
				</option>
			</select>
		</div>
		<div class="d-flex">
			<button
				type="button"
				:class="{ 'btn-blue': getRealEstates.length === 0, 'btn-blue-inverse': getRealEstates.length > 0 }"
				class="btn m-auto mt-30px"
				@click="selectNewRealEstate"
				:style="getRealEstates.length > 0 ? 'margin-right: 15px;' : ''"
			>
				Új ingatlan
			</button>
			<button
				v-if="getRealEstates.length > 0"
				type="button"
				class="btn btn-blue m-auto mt-30px"
				@click="selectRealEstate"
				style="margin-left: 15px"
			>
				Tovább
			</button>
		</div>
	</div>
</template>

<script>
import Select from '@/components/elements/Select';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CampaignHelper from '@/helpers/campaignHelper.js';
import moment from "moment";

export default {
	mounted() {
		if (this.getRealEstates.length > 0) {
			this.selected = this.getRealEstates[0].id;
		}

        this.isItHomeInsuranceCampaign = CampaignHelper.isItHomeInsuranceCampaign();
	},
	components: {
		Select,
	},
	data() {
		return {
			selected: null,
            isItHomeInsuranceCampaign: false
		};
	},
	computed: {
		...mapGetters(['getRealEstates']),
	},
	methods: {
		...mapMutations(['showPopup']),
		...mapActions(['setSelectedRealEstateData', 'clearSelectedRealEstateData']),

		selectRealEstate() {
			this.setSelectedRealEstateData(this.selected);

            if (this.isItHomeInsuranceCampaign) {
                this.$router.push({ name: 'property-details' });
            }
            else {
                this.$router.push({name: 'is-company'});
            }

			this.showPopup(null);
		},

		selectNewRealEstate() {
			this.clearSelectedRealEstateData();

            if (this.isItHomeInsuranceCampaign) {
                this.$router.push({ name: 'property-details' });
            }
            else {
                this.$router.push({name: 'is-company'});
            }

			this.showPopup(null);
		},

		makeAddress(realEstate) {
			let address = `${realEstate.postal_code} ${realEstate.city}, ${realEstate.address} `;

			if (realEstate.house_number !== null) {
				address = `${address} ${realEstate.house_number}.`;
			} else {
				address = `${address} | ${realEstate.parcel_number}`;
			}

            address = `${address} (${moment(realEstate.updated_at).format('YYYY. MM. DD. HH:mm:ss')})`;

			return address;
		},
	},
};
</script>
